import { useMutationUpdateRiskProperty } from 'api/mutations/UpdateRiskProperty.mutation';

export const useStatusCellProvider = () => {
    return {
        api: {
            updateRiskProperty: {
                instance: useMutationUpdateRiskProperty(),
            },
        },
    };
};
